import { render, staticRenderFns } from "./Prqs.vue?vue&type=template&id=1a27bb00&scoped=true"
import script from "./Prqs.vue?vue&type=script&lang=js"
export * from "./Prqs.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Prqs.vue?vue&type=style&index=1&id=1a27bb00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27bb00",
  null
  
)

export default component.exports